/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Operatore di confronto del predicato
 */
export enum OperatorePredicato {

    PRESENTE = 'PRESENTE',

    ASSENTE = 'ASSENTE',

    EQ = 'EQ',

    NEQ = 'NEQ',

    IN = 'IN',

    NOT_IN = 'NOT_IN',

    GT = 'GT',

    GTE = 'GTE',

    LT = 'LT',

    LTE = 'LTE',

    RANGE_CHIUSO = 'RANGE_CHIUSO',

    RANGE_APERTO = 'RANGE_APERTO',

    RANGE_MIN_INCLUSO_MAX_ESCLUSO = 'RANGE_MIN_INCLUSO_MAX_ESCLUSO',

    RANGE_MIN_ESCLUSO_MAX_INCLUSO = 'RANGE_MIN_ESCLUSO_MAX_INCLUSO'
}

